import { useQuery } from '@tanstack/react-query'

import { apiGetGachaRecentWinners } from '@/apis/gacha/getGachaRecentWinners'

import { GACHA_KEYS } from '../keys/gacha'

const DEFAULT_PAGE = 0
const DEFAULT_SIZE = 20

interface UseGetGachaRecentWinnersOptions {
  size?: number
  refetchInterval?: number
}

export const useGetGachaRecentWinners = (gachaEventId: number, options?: UseGetGachaRecentWinnersOptions) => {
  const size = options?.size ?? DEFAULT_SIZE
  return useQuery({
    queryKey: [GACHA_KEYS.RECENT_WINNERS, gachaEventId, size],
    queryFn: () => apiGetGachaRecentWinners(gachaEventId, DEFAULT_PAGE, size),
    refetchInterval: options?.refetchInterval,
  })
}
